/**
 *
 * Button
 *
 */
import React, { forwardRef } from 'react';
import { Link } from 'lib/router';

import { LoaderDots } from 'app/components/LoaderDots';

import { Wrapper, ButtonContent, LoadingWrapper } from './styles';

interface Props {
  variant: string;
  children: React.ReactNode;
  type?: 'button' | 'link' | 'submit';
  to?: string;
  iconRight?: boolean;
  onlyIcon?: boolean;
  loading?: boolean;
  whiteLoader?: boolean;
  bg?: string;
  color?: string;
  borderColor?: string;
  colorLoader?: boolean;
  onClick?(e?): void;
  [x: string]: any;
}

export const Button = forwardRef(
  (
    {
      variant,
      children,
      type = 'button',
      to,
      iconRight,
      onlyIcon,
      loading,
      onClick,
      bg,
      color,
      whiteLoader = true,
      borderColor,
      colorLoader = false,
      ...props
    }: Props,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    return (
      <Wrapper
        as={type === 'link' ? Link : 'button'}
        type={type}
        to={to ?? ''}
        variant={variant}
        bg={bg}
        color={color}
        borderColor={borderColor ? borderColor : ''}
        onClick={e => {
          e && e.stopPropagation();
          onClick && onClick();
        }}
        {...props}
      >
        <ButtonContent
          mr={iconRight ? 0 : onlyIcon ? 0 : 2}
          ml={iconRight ? 2 : 0}
          ref={ref || null}
          display="flex"
          alignItems="center"
          justifyContent="center"
          width="100%"
        >
          {loading ? (
            <LoadingWrapper color="white">
              <LoaderDots white={colorLoader ? false : true} size="14px" />
            </LoadingWrapper>
          ) : (
            <>{children}</>
          )}
        </ButtonContent>
      </Wrapper>
    );
  },
);
